import { Instagram, Mail, Network, Shell } from 'lucide-react';
import { FormEvent } from 'react';
import CtaBand from '../components/CtaBand';

export default function Contact() {
  const send = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    const subject = encodeURIComponent(`Vague de Mots — ${String(data.get('prestation') || 'Demande de contact')}`);
    const body = encodeURIComponent(`Nom : ${String(data.get('nom') || '')}\nE-mail : ${String(data.get('email') || '')}\nPrestation : ${String(data.get('prestation') || '')}\n\n${String(data.get('message') || '')}`);
    window.location.href = `mailto:vaguedemots.services@gmail.com?subject=${subject}&body=${body}`;
  };

  return (
    <>
      <section className="contact-hero">
        <div className="container-wide contact-hero-inner">
          <div className="contact-hero-copy">
            <span className="eyebrow">Contact</span><div className="mini-wave" />
            <h1>Et si nous parlions<br /><em>de votre histoire ?</em></h1>
            <h3>Chaque beau projet commence par un échange.</h3>
            <p>Vous avez terminé votre manuscrit, vous êtes en pleine écriture ou vous souhaitez simplement obtenir des renseignements ?<br />Je serai ravie de vous lire et d’échanger avec vous.</p>
            <div className="shell-rule"><Shell size={28} /><span /></div>
          </div>
          <div className="contact-photo" />
        </div>
      </section>

      <section className="contact-content container-wide">
        <div className="contact-form-card">
          <h2>Votre message</h2><div className="mini-wave" />
          <p>Remplissez le formulaire ci-dessous et je vous répondrai dans les meilleurs délais.</p>
          <form onSubmit={send}>
            <label>Nom et prénom <b>*</b><input name="nom" required placeholder="Votre nom et prénom" autoComplete="name" /></label>
            <label>Adresse e-mail <b>*</b><input type="email" name="email" required placeholder="votre@email.fr" autoComplete="email" /></label>
            <label>Prestation concernée <b>*</b><select name="prestation" required defaultValue=""><option value="" disabled>Sélectionnez une prestation</option><option>Premier Regard</option><option>Immersion</option><option>Grand Large</option><option>Ligne Claire</option><option>Autre / renseignement</option></select></label>
            <label>Votre message <b>*</b><textarea name="message" required rows={6} placeholder="Parlez-moi de votre projet, de votre manuscrit ou de vos questions…" /></label>
            <p className="required-note">* Champs obligatoires</p>
            <button className="button button-clay submit-button" type="submit">Envoyer mon message <span>→</span></button>
          </form>
        </div>
        <aside className="contact-aside">
          <h2><Shell size={30} /> Autres moyens<br />de me contacter</h2><div className="mini-wave" />
          <a href="mailto:vaguedemots.services@gmail.com"><Mail /><span><b>E-mail</b><small>vaguedemots.services@gmail.com</small></span></a>
          <a href="https://www.instagram.com/vague_demots/" target="_blank" rel="noreferrer"><Instagram /><span><b>Instagram</b><small>@vague_demots</small></span></a>
          <div className="contact-social"><Network /><span><b>Réseaux</b><small>Retrouvez-moi également sur Threads et échangeons autour de l’écriture et de la correction.</small></span></div>
          <blockquote><span>“</span>Les mots sont des vagues :<br />parfois ils bousculent,<br />parfois ils apaisent,<br />mais ils laissent toujours<br />une empreinte.<span>”</span><Shell size={28} /></blockquote>
        </aside>
      </section>
      <CtaBand title="Vous avez un projet et souhaitez en discuter ?" action="Prendre rendez-vous" />
    </>
  );
}
